import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { RECORDABLE_ENTRY_TYPES } from '@workspace/utils'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { REGISTER_WRITE_ROLES } from '@/features/medication-register/access'
import { RecordEntryPage } from '@/features/medication-register/record-entry-page'

const searchSchema = z.object({
  // Which Record button opened the page. `administration` is absent on
  // purpose: doses arrive from the shift/chart side, where the administration
  // record answers for the ledger line.
  type: z.enum(RECORDABLE_ENTRY_TYPES),
})

/** Recording a ledger line is a manager write (X2). */
export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/drugs-register/$accountId/record'
)({
  beforeLoad: async () => {
    await requireRoles([...REGISTER_WRITE_ROLES])
    await requireActiveSubscription()
  },
  validateSearch: searchSchema,
  component: RecordEntryPage,
})
